import axios from 'axios';
 
export const getCurrentLocation=()=>{
    return new Promise((resolve, reject) => {
        var location = {};
        var url = 'https://www.googleapis.com/geolocation/v1/geolocate?key=' + process.env.VUE_APP_GOOGLE_MAP_API_KEY;
        axios.post(url,{"considerIp":"true"})
            .then(function (resp) {
                location.lat = resp.data.location.lat;
                location.lng = resp.data.location.lng;
                // var url2 = 'https://maps.googleapis.com/maps/api/geocode/json?latlng='+resp.data.location.lat +','+resp.data.location.lng+'&key=' + process.env.VUE_APP_GOOGLE_MAP_API_KEY;
                var url2 = 'https://gjwmybgxbl.execute-api.us-west-2.amazonaws.com/geocode?lat='+resp.data.location.lat +'&lng='+resp.data.location.lng;
                axios.get(url2)
                    .then(function (response) {
                        var addr = response.data.results[0];
                        if(addr){
                            location.address = addr.formatted_address;
                            for (var i = 0; i < addr.address_components.length; i++) {
                                var addressType = addr.address_components[i].types[0];
                                if(addressType=='locality'){
                                    location.city = addr.address_components[i].long_name
                                }
                                if(addressType=='country'){
                                    location.country = addr.address_components[i].long_name
                                }
                                if(addressType=='country'){
                                    location.countryCode = addr.address_components[i].short_name
                                }
                            }
                            resolve(location)
                        }
                    })
                    .catch(function (error) {
                        reject(error)
                    });
            })
            .catch(function (error) {
                reject(error)
            });
    });
}
 